// translationSlice.js
import { createSlice } from '@reduxjs/toolkit';
const common_en = require("../../translations/en/en_translations.json");

const translationSlice = createSlice({
  name: 'translation',
  initialState: {
    persistTranslationResources: {
      en: {
        translations: common_en,
      }
    },
  },
  reducers: {
    setTranslationResources: (state, action) => {
      state.persistTranslationResources = action.payload;
    },
  },
});

export const { setTranslationResources } = translationSlice.actions;

export default translationSlice.reducer;